import { Component, output, input } from '@angular/core';
import { RxInputModule } from '../../../input/input.module';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  imports: [RxInputModule, CommonModule],
  selector: 'rx-dropdown-search',
  templateUrl: './dropdown-search.component.html',
  styleUrls: ['./dropdown-search.component.scss'],
})
export class DropdownSearchComponent {
  ariaLabel = input('Dropdown Search');
  disabled = input(false);
  readonly = input(false);
  filterValue = input<string>();
  placeholder = input<string>('');
  isDropdownOpen = input<boolean>();

  onInputFocus = output();
  onInputBlur = output();
  onFilter = output();

}
